import React, { useState } from "react"
import styled from "styled-components"
import { useTranslation } from "react-i18next"

import eye from "../images/icon_eye.svg"
import eyeClosed from "../images/icon_eyeClosed.svg"

const ShowHideButton = ({ className, onClick, isShown }) => {
  const { t } = useTranslation("generic")

  return (
    <button className={className} onClick={e => { e.preventDefault(); onClick(); }}>
      {!isShown && <img src={eyeClosed} alt={t("##.Profile.Password.ShowPassword")} />}
      {isShown && <img src={eye} alt={t("##.Profile.Password.HidePassword")} />}
    </button>
  )
}

const StyledShowHideButton = styled(ShowHideButton)`
  border: none;
  background-color: transparent;
  cursor: pointer;
  width: 20px;
  & img {
    width: 100%;
    filter: ${props => props.theme.color.textFilter};
  }
`

const PasswordInput = ({ id, autoComplete, labelId, onChange, className }) => {
  const [isVisible, setIsVisible] = useState(false)

  return (
    <div className={className}>
      <input
        id={id}
        type={isVisible? `text` : `password`}
        autoComplete={autoComplete}
        aria-labelledby={labelId}
        onChange={onChange}
      />
      <StyledShowHideButton isShown={isVisible} onClick={() => setIsVisible(val => !val)} />
    </div>
  )
}

const StyledPasswordInput = styled(PasswordInput)`
  display: inline-block;
  width: 100%;
  position: relative;
  & ${StyledShowHideButton} {
    position: absolute;
    top: 5px;
    right: 5px;
  }
`

export default StyledPasswordInput
